import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useEffect } from 'react';
export var useOuterClick = function useOuterClick(scopeNodes, onClick) {
  var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  useEffect(function () {
    var onOuterClick = function onOuterClick(event) {
      var _a;

      var targetNode = event.target;

      if (!enabled || !scopeNodes.length || !targetNode) {
        return;
      }

      var isOuterClick = true;

      for (var i = 0; i < scopeNodes.length; i += 1) {
        var node = scopeNodes[i];

        if ((_a = node === null || node === void 0 ? void 0 : node.current) === null || _a === void 0 ? void 0 : _a.contains(targetNode)) {
          isOuterClick = false;
          break;
        }
      }

      if (isOuterClick) {
        onClick(event);
      }
    };

    document.addEventListener('mousedown', onOuterClick);
    return function () {
      document.removeEventListener('mousedown', onOuterClick);
    };
  }, [].concat(_toConsumableArray(scopeNodes), [onClick, enabled]));
};